import React from 'react';
import ConfirmMailContent from 'components/authentication/ConfirmMailContent';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { useLocation, useNavigate } from 'react-router-dom';

const ConfirmMail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get('email');

  // Get the part after the #
  const hash = location.hash;

  // Remove # at start
  const query = hash.substring(1);

  // Split into parts
  const params = new URLSearchParams(query);

  // Extract error params
  const error = params.get('error');
  const errorCode = params.get('error_code');
  const errorDescription = params.get('error_description');
  console.log('error', error + errorDescription);

  if (error) {
    return (
      <AuthCardLayout>
        <div className="text-center">
          <p>{errorDescription}</p>
        </div>
      </AuthCardLayout>
    );
  }

  return (
    <AuthCardLayout>
      <div className="text-center">
        <ConfirmMailContent layout="card" email={email} titleTag="h3" />
      </div>
    </AuthCardLayout>
  );
};

export default ConfirmMail;
